import * as Dialog from '@radix-ui/react-dialog';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

/**
 * A yes/no confirmation, a centred dialog like the reports' «Rifiuta» (board #667). Shared by the
 * discard on the approvals and the three choices of the profile's journey.
 */
export function ConfirmDialog({
  title,
  ask,
  confirmLabel,
  destructive = false,
  busy,
  onConfirm,
  onClose,
}: {
  readonly title: string;
  readonly ask: string;
  readonly confirmLabel: string;
  readonly destructive?: boolean;
  readonly busy: boolean;
  readonly onConfirm: () => void;
  readonly onClose: () => void;
}) {
  const { t } = useTranslation('communications');
  return (
    <Dialog.Root open onOpenChange={(next) => (next ? undefined : onClose())}>
      <Dialog.Portal>
        {/* z-60: above the side panel (51) a confirmation may be asked from. */}
        <Dialog.Overlay className="fixed inset-0 z-[60] bg-[var(--scrim)]" />
        <Dialog.Content className="border-border bg-card fixed top-1/2 left-1/2 z-[60] grid w-[min(26rem,calc(100vw-2rem))] -translate-x-1/2 -translate-y-1/2 gap-4 rounded-xl border p-6 shadow-lg">
          <Dialog.Title className="text-foreground text-lg font-semibold">{title}</Dialog.Title>
          <Dialog.Description className="text-muted-foreground text-sm">{ask}</Dialog.Description>
          <div className="flex flex-wrap justify-end gap-2">
            <Button type="button" variant="outline" className="min-h-11" onClick={onClose}>
              {t('common.cancel')}
            </Button>
            <Button
              type="button"
              variant={destructive ? 'destructive' : 'default'}
              className="min-h-11"
              disabled={busy}
              onClick={onConfirm}
            >
              {confirmLabel}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
